export const CONNECT_EVENT = 'connect'
export const ERROR_EVENT = 'error'
export const CLOSE_EVENT = 'close'
export const ACCOUNTS_CHANGED = 'accountsChanged'
export const CHAIN_CHANGED = 'chainChanged'
export const THEME_CHANGED = 'themeChanged'
export const LANGUAGE_CHANGED = 'languageChanged'
